//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { go } from '../../libs/router'

export default {
  props: ['icon', 'label', 'link'],
  mounted () {
    this.$slots.icon && (this.hasIconSlot = true)
    this.$slots.label && (this.hasLabelSlot = true)
  },
  computed: {
    style () {
      const rows = this.$parent.rows
      if (!rows || rows === 3) {
        return
      }
      const styles = {}
      styles.width = `${100 / rows}%`
      return styles
    }
  },
  methods: {
    onClick () {
      this.$emit('on-item-click')
      go(this.link, this.$router)
    }
  },
  data () {
    return {
      hasIconSlot: false,
      hasLabelSlot: false
    }
  }
}



// WEBPACK FOOTER //
// ./~/vux/src/components/grid/grid-item.vue